module.exports = __webpack_public_path__ + "static/media/quantrol.32ee2f8b.pdf";